import * as React from 'react';

export type ContextType = Map<
  'description' | 'characteristics' | 'collectionProducts' | 'complements' | 'substitutes' | 'reviews',
  React.MutableRefObject<HTMLElement | null>
>;

export const Context = React.createContext<ContextType>(new Map());
